import { useState } from "react";

export const useField = ({ initialValue }: { initialValue?: string | null }) => {
  const [value, setValue] = useState(initialValue ?? "");
  const onChange = (e: any) => setValue(e.target.value);

  return {
    value,
    onChange,
  };
};
